import { useMemo } from 'react';

import { useStatisticOptions } from '../store';

import { useStatisticCategory } from './category';
import { useStatisticFilters } from './filters';

import { useStatDefinitions } from '@hooks/useStatDefinitions';

export const useStatisticTypes = () => {
  const { options } = useStatisticOptions();
  const { category } = useStatisticCategory();
  const { filters } = useStatisticFilters();

  const phase = useMemo(() => filters?.phase.toLowerCase(), [filters?.phase]);

  const statTypes: string[] = useMemo(
    () => options.statTypes?.[phase]?.[category],
    [options.statTypes, phase, category],
  );

  const types = useStatDefinitions(statTypes);

  return { types };
};
